export default {
    BusinessPurchaseDetailPage: {
        order: 'Purchase Order Status',
        Receipt: 'Inventory Status',
        quantity: 'Purchase Quantity',
        Received: 'Received Quantity',
        Not: 'Not Received Quantity',
        Data: 'Data Fault Tolerance',
        Basic: 'Purchase Order Account Information',
        number: 'Purchase Order No.',
        type: 'Purchase Type',
        Receiving: 'Receiving Warehouse',
        Creation: 'Creation Date',
        Approval: 'Approval Date',
        Completion: 'Completion Date',
        Buyer: 'Buyer',
        requisi: 'Purchase Requisition Number',
        Remarks: 'Remarks',
        info: 'Product Information',
        table: {
            Purchase: 'Purchase Quantity',
            Quantity: 'In-Production Quantity',
            transit: 'In-Transit Quantity',
            not: 'Not Received Quantity',
            Received: 'Received Quantity',
            Australian: 'AUD Purchase Price',
            Selling: 'Selling Price',
            Link: 'Link',
            Price: 'Link Lowest Price',
            Express: 'Shipping Cost',
            Consumption: 'Consumption Tax',
            Platform: 'Platform Fees',
            Estimated: 'Estimated Profit',
            Expected: 'Estimated Profit Margin',
            Actual: 'Actual Profit Margin',
            risk: 'Purchase Risk Indicator',
            Barcode: 'Barcode',
            cartonBoxBarcode: 'Barcode on outer box',
            brand: 'Product Brand',
            Product1: 'Product Category 1',
            Product2: 'Product Category 2',
            Description: 'Product Description',
            length: 'Product Length',
            width: 'Product Width',
            high: 'Product Height',
            Volume: 'Product Volume',
            Weight: 'Product Weight',
            boxLength: 'Box Length',
            boxWidth: 'Box Width',
            boxheight: 'Box Height',
            boxVolume: 'Box Volume',
            boxWeight: 'Box Weight',
            per: 'Item Per Box',
            Buyer: 'Buyer',
        },
        Associated: 'Associated Documents',
        dataForm: {
            type: 'Document Type',
            number: 'Purchase Receipt Number',
            status: 'Purchase Receipt Status',
            time: 'Creation Date',
            by: 'Created By',
        },
        plantQtySum: 'Total Ordered Quantity',
        productVolume: 'Total Product Volume',
        cartonWeight: 'Total Carton Weight',
        contractNo: 'Contract Number',
        planQty: 'Document Quantity',
        signDate: 'Signing Time',
        execStatus: 'Execution Status',
        tab1: 'Product Details',
        tab2: 'Product-Related Contract',
    }
};
